import { useQuery } from "@tanstack/react-query";
import { reviewerApi } from "@/lib/api";

export interface InternalNote {
  note_id: string;
  body: string;
  author_actor: string;
  created_at: string;
}

/**
 * Lazy-fetch operator-internal notes for the Applicant page "View notes"
 * panel. `enabled` is gated on `hasOpened` so we don't hit the backend
 * until the operator actually expands the panel.
 *
 * Invalidated by `reviewerApi.addNote` success via the shared key
 * `["reviewer", "notes", inquiryId]`.
 */
export function useInternalNotes(inquiryId: string | null | undefined, hasOpened: boolean) {
  return useQuery({
    queryKey: ["reviewer", "notes", inquiryId],
    queryFn: async () => {
      const res = await reviewerApi.listNotes(inquiryId!);
      // Backend returns chronological order; sort newest-first for display.
      const notes = [...(res.notes ?? [])].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );
      return notes as InternalNote[];
    },
    enabled: hasOpened && !!inquiryId,
    staleTime: 30_000,
  });
}
